import { formatCurrency } from '~/shared/utils/formatCurrency';
import {
  ReceiptBox,
  ReceiptLabel,
  ReceiptRow,
  ReceiptValue,
} from '~/modules/matters/modals/shared/retainerModalStyles';

interface Props {
  isFlatRate: boolean;
  flatAmount: number;
  rateDisplayLabel: string;
  hours: number;
  subtotal: number;
  platformFee?: number;
  total?: number;
}

const RetainerReceiptSummary = ({
  isFlatRate,
  flatAmount,
  rateDisplayLabel,
  hours,
  subtotal,
  platformFee,
  total,
}: Props) => (
  <ReceiptBox>
    {isFlatRate ? (
      <>
        <ReceiptRow>
          <ReceiptLabel>Rate</ReceiptLabel>
          <ReceiptValue>{formatCurrency(flatAmount)}</ReceiptValue>
        </ReceiptRow>
        <ReceiptRow>
          <ReceiptLabel>Subtotal</ReceiptLabel>
          <ReceiptValue>{formatCurrency(subtotal)}</ReceiptValue>
        </ReceiptRow>
      </>
    ) : (
      <>
        <ReceiptRow>
          <ReceiptLabel>Rate</ReceiptLabel>
          <ReceiptValue>{rateDisplayLabel}</ReceiptValue>
        </ReceiptRow>
        <ReceiptRow>
          <ReceiptLabel>Hours</ReceiptLabel>
          <ReceiptValue>{hours}</ReceiptValue>
        </ReceiptRow>
        <ReceiptRow>
          <ReceiptLabel>Subtotal</ReceiptLabel>
          <ReceiptValue>{formatCurrency(subtotal)}</ReceiptValue>
        </ReceiptRow>
      </>
    )}
    {platformFee !== undefined && (
      <ReceiptRow>
        <ReceiptLabel>Platform fee</ReceiptLabel>
        <ReceiptValue>{formatCurrency(platformFee)}</ReceiptValue>
      </ReceiptRow>
    )}
    {total !== undefined && (
      <ReceiptRow>
        <ReceiptLabel>Total</ReceiptLabel>
        <ReceiptValue>{formatCurrency(total)}</ReceiptValue>
      </ReceiptRow>
    )}
  </ReceiptBox>
);

export default RetainerReceiptSummary;
